var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.code)?_c('div',[_vm._v(" "+_vm._s(_vm.code)+" "),_c('mt-button',{on:{"click":function($event){return _vm.copyItem({ code: _vm.code }, $event)}}},[_vm._v("复制")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }